import { AdvisorWebSocketState } from '../types/advisorWebsocket'

export const initialState: AdvisorWebSocketState = {
  isConnected: false,
  error: null,
}
